@if(fetchingHtml){
<div class="row">
	<div class="col-md-12">
		<div class="text-center">
			<img src="../../../assets/img/loading.gif" class="w-100px" />
		</div>
	</div>
</div>
}
<iframe #iframe frameborder="0" scrolling="yes" (load)="resizeIframe(iframe)" [ngStyle]="style">
</iframe>